import { render, staticRenderFns } from "./RegistrationList.vue?vue&type=template&id=a9003f4c&"
import script from "./RegistrationList.vue?vue&type=script&lang=js&"
export * from "./RegistrationList.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationList.vue?vue&type=style&index=0&id=a9003f4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports